import { clearStudyDemoDrafts } from './lifecycle';
import { useState, type ReactNode } from 'react';
import { LearnViewportContext } from '@/app/LearnViewportContext';
import { SAMPLE_PROFILE, sampleExitPath } from './sampleProfile';

/** Only the isolated local example uses this viewport boundary. */
export function SampleWorkspaceFrame({ children, exitTo = sampleExitPath }: { children: ReactNode; exitTo?: string }) {
  const [viewport, setViewport] = useState<HTMLDivElement | null>(null);
  return (
    <section
      aria-label="Example workspace"
      data-study-fullscreen-boundary
      data-testid="sample-workspace-frame"
      className="flex h-full min-h-0 min-w-0 flex-col border-2 border-brand-sky bg-canvas"
    >
      <header className="flex shrink-0 items-center justify-between gap-3 px-3 text-xs text-ink">
        <p className="font-extrabold">Example mode · {SAMPLE_PROFILE.nickname}</p>
        <button
          type="button"
          className="min-h-11 px-2 text-xs font-bold text-slate2 underline"
          onClick={() => {
            clearStudyDemoDrafts();
            window.history.replaceState(
              null,
              '',
              `${window.location.pathname}${window.location.search}#/learn/study`,
            );
            window.location.reload();
          }}
        >
          Reset example
        </button>
      </header>
      <div
        ref={setViewport}
        data-testid="sample-product-viewport"
        className="relative min-h-0 min-w-0 flex-1 [contain:layout]"
      >
        <LearnViewportContext.Provider value={viewport}>{children}</LearnViewportContext.Provider>
      </div>
      <footer className="shrink-0 border-t border-hairline bg-canvas-pure px-3 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        <a
          className="btn-pill-primary mx-auto flex min-h-12 w-full max-w-xl items-center justify-center text-base"
          href={exitTo}
          onClick={() => clearStudyDemoDrafts()}
        >
          Exit example
        </a>
      </footer>
    </section>
  );
}
